/**
 * To prevent Safari from canceling API requests when they run concurrently with a URL redirect,
 * a default 0.5-second delay is introduced to help ensure the API request is sent.
 * @param {string} url
 * @param {number} delay - default 500 milliseconds, it's a rough estimate to prevent Safari from canceling API requests.
 * @returns {void}
 */
export const delayRedirect = (url, delay = 500) => {
  setTimeout(() => {
    window.location.href = url;
  }, delay);
};

/**
 * Redirect via POST form submission (required for OmniAuth v2.0.0+).
 * Dynamically creates a hidden form with CSRF token and submits it.
 *
 * A delay is introduced before form submission to allow any in-flight events
 * (e.g. click, analytics tracking) to complete before the page navigates away.
 * Without the delay, the browser may cancel pending events when the form submission
 * triggers a navigation too quickly.
 *
 * @param {string} url - The target URL (query params will be converted to hidden fields)
 * @param {number} delay - Optional delay in ms before submitting (default 500, same as delayRedirect)
 */
export const postRedirect = (url, delay = 500) => {
  setTimeout(() => {
    const [pathname, search] = url.split('?');
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = pathname;
    form.style.display = 'none';

    const csrfToken = document
      .querySelector('meta[name=csrf-token]')
      ?.getAttribute('content');
    if (csrfToken) {
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'authenticity_token';
      tokenInput.value = csrfToken;
      form.appendChild(tokenInput);
    }

    if (search) {
      const params = new URLSearchParams(search);
      params.forEach((value, key) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });
    }

    document.body.appendChild(form);
    form.submit();
  }, delay);
};
